module.exports = __webpack_public_path__ + "media/images/athletes/3559-0f33621419fafdc2e22ba3c6496a6052.png";